export var getLocalizedHref = function getLocalizedHref() {
  var link = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var t = arguments.length > 1 ? arguments[1] : undefined;
  var defaultLink = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var translationOptions = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  if (link.startsWith('/') || link.startsWith('http')) {
    return link;
  }
  var translatedLink = t(link, translationOptions);
  if (link === translatedLink) {
    return defaultLink;
  }
  return translatedLink.startsWith('/') || translatedLink.startsWith('http') ? translatedLink : "/".concat(translatedLink);
};